import axios from 'axios';

const BASE_URL = process.env.REACT_APP_ROOT_API_URL;
const Request = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

Request.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;

    // Not authorized, try to refresh token
    if (error.response.status === 401) {
      const [isFail, response] = await axios({
        method: 'POST',
        url: `${BASE_URL}/users/token/refresh/`,
        withCredentials: true,
      })
        .then(async () => ([false, await axios.request(originalRequest)]))
        .catch(() => ([true, null]));

      return isFail ? Promise.reject(isFail) : Promise.resolve(response);
    }
    return Promise.reject(error);
  },
);

export default Request;
